import {
  USER_LOGIN_RESPONSE,
  USER_REGISTERED_RESPONSE,
} from "../constants/text_constants";
import { UNPROTECTED_ROUTES } from "../routes/routes";
import { setUserData, setAuthentication } from "../configs/userSlice";
import saveAuthToken from "./saveAuthToken";

const userLogin = async (api, navigate, dispatch) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_TEMP_TOKEN}`,
      },
    };

    const response = await fetch(api, requestOptions);
    const json = await response.json();

    if (!response.ok) {
      console.error("Login API error:", json);
      return;
    }

    if (!saveAuthToken(json?.data?.token)) {
      console.error("Login response did not include a valid token");
      return;
    }

    const userData = {
      userName: json?.data?.name,
      userEmail: json?.data?.email,
      userAddress: json?.data?.address,
      country: json?.data?.country_id,
      state: json?.data?.state_id,
      city: json?.data?.city_id,
      pincode: json?.data?.zipcode,
      userMobile: json?.data?.mobile,
      userId: json?.data?.user_id,
      referralCode: json?.data?.referral_code,
    };

    sessionStorage.setItem("userDetail", JSON.stringify(userData));
    sessionStorage.setItem("authenticated", "1");

    window.dispatchEvent(new Event("rankplus-auth-state-change"));
    dispatch(setAuthentication());

    if (json?.message === USER_LOGIN_RESPONSE) {
      const tempdata = json?.data?.tempdata;

      if (
        tempdata?.email === "" ||
        tempdata?.name === "" ||
        tempdata?.country_id === "" ||
        tempdata?.state_id === "" ||
        tempdata?.city_id === "" ||
        tempdata?.zipcode === ""
      ) {
        dispatch(setUserData(json?.data));
        navigate(UNPROTECTED_ROUTES?.studentDetails);
        return;
      }

      dispatch(setUserData(json?.data));
      navigate(UNPROTECTED_ROUTES?.home);

    } else if (json?.message === USER_REGISTERED_RESPONSE) {
      dispatch(setUserData(json?.data));
      navigate(UNPROTECTED_ROUTES?.studentDetails);
    }

  } catch (err) {
    console.error("Error userLogin", err);
  }
};

export default userLogin;
